<template>
<div>
      <header class="header header--style-one">
        <div class="header__status has-bg color-light">
            <div class="container">
                <div class="row">
                    <div class="col-8 col-sm-6 ">
                        <ul class="header__status__items header__status__items--left">
                            <li><i class="fa fa-calendar"></i>{{ now | day }}, {{ now | date }}</li>
                            <li class="d-none d-xl-block d-lg-block"><i class="fa fa-clock-o"></i>{{ now |time }}</li>
                        </ul>
                    </div>
                    <div class="col-4 col-sm-6">
                        <ul class="header__status__items header__status__items--right">
                             <li class="header__status__social d-none d-xl-block d-lg-block pr-0">
                                <router-link :to="{ name:'dojavi-vijest'}">Dojavi vijest</router-link>
                            </li>
                            <li class="header__status__social d-none d-xl-block d-lg-block pr-0">
                                <router-link :to="{ name:'kursna-lista'}">Kursna lista</router-link>
                            </li>
                             <li class="header__status__social d-none d-xl-block d-lg-block pr-0">
                                <router-link :to="{ name:'marketing'}">Marketing</router-link>
                            </li>
                            <li class="header__status__social d-none d-xl-block d-lg-block pr-0">
                                <router-link :to="{ name:'kontakt'}">Kontakt</router-link>
                            </li>
                            <li class="header__status__social d-none d-xl-block d-lg-block">
                                <a v-if="socialNetworks.facebookPage" v-bind:href="socialNetworks.facebookPage" target="_blank"><i class="fa fa-facebook"></i></a>
                                <a v-if="socialNetworks.twitterPage" v-bind:href="socialNetworks.twitterPage" target="_blank"><i class="fa fa-twitter"></i></a>
                                <a v-if="socialNetworks.instagramPage" v-bind:href="socialNetworks.instagramPage" target="_blank"><i class="fa fa-instagram"></i></a>
                                <a v-if="socialNetworks.youtubeChannel" v-bind:href="socialNetworks.youtubeChannel" target="_blank"><i class="fa fa-youtube"></i></a>
                            </li>

                        </ul>
                    </div>
                </div> <!--//.row -->
            </div>
        </div> 
        <app-Navbar></app-Navbar>
    </header>
</div>
</template>

<script>
    import { NewsService, AboutService } from '../common/api.service'
    import Navbar from './Navbar.vue'

    export default {
        name: "Header",
        components: {
            appNavbar: Navbar
        },
        data() {
            return {
                now: new Date,
                socialNetworks: {}
            }
        }, 
        created() {
            setInterval(() => this.now = new Date, 1000 * 5);
            this.fetchData();
        },
        methods: {
            fetchData: function() {     
                AboutService.getSocialNetworksInfo().then(res => this.socialNetworks = res.data);
            },
            nextNews() {
                this.$refs.carousel.next();
            },
            prevNews() {
                this.$refs.carousel.prev();
            }
        }
    }
</script>

<style scoped>
    .carousel  {
        -webkit-user-select: auto !important; /* Safari */
         -ms-user-select: auto !important; /* IE 10+ and Edge */
        user-select: auto !important; /* Standard syntax */
        width: 90% !important;
    }

    .header .header__status.color-light li, .header .header__status.color-light li a {
        color: #a5a5a5;
        border:0px;
    }

    .header .header__status {
        height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue